// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/opt/build/repo/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-info-js": () => import("/opt/build/repo/src/pages/info.js" /* webpackChunkName: "component---src-pages-info-js" */),
  "component---src-pages-preferits-js": () => import("/opt/build/repo/src/pages/preferits.js" /* webpackChunkName: "component---src-pages-preferits-js" */)
}

exports.data = () => import("/opt/build/repo/.cache/data.json")

